export const MAX_LIST_ITEMS = 24
export const DEFAULT_LIST_PAGE = 1
